/* MygicTouch product page behaviour
   - keeps the savings pill in sync with the selected variant
   - shows the sticky add to cart once the real button scrolls out of view
   Motion dispatches `variant:change` on document with detail.variant */
(function () {
  'use strict';

  var money = function (cents) {
    if (typeof cents !== 'number') return '';
    var v = cents / 100;
    var s = v % 1 === 0 ? v.toFixed(0) : v.toFixed(2);
    return '\u20B9' + s.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  };

  /* ---------- savings pill ---------- */
  function updatePill(variant) {
    var pill = document.querySelector('[data-mgt-save]');
    if (!pill) return;
    if (!variant || !variant.compare_at_price || variant.compare_at_price <= variant.price) {
      pill.hidden = true;
      return;
    }
    var save = variant.compare_at_price - variant.price;
    var pct = Math.round((save / variant.compare_at_price) * 100);
    pill.textContent = 'Save ' + money(save) + ' (' + pct + '%)';
    pill.hidden = false;
  }

  /* ---------- sticky add to cart ---------- */
  function initSticky() {
    var bar = document.querySelector('[data-mgt-sticky]');
    if (!bar) return;

    var form = document.querySelector('.product-single__meta form[action*="/cart/add"]');
    var realBtn = document.querySelector('.product-single__meta [data-add-to-cart]');
    var anchor = realBtn || document.querySelector('.product-single__meta');
    if (!anchor) return;

    var stickyBtn = bar.querySelector('[data-mgt-sticky-btn]');
    var priceNow = bar.querySelector('[data-mgt-sticky-price]');
    var priceWas = bar.querySelector('[data-mgt-sticky-compare]');

    // clicking the sticky button submits the real form so Motion's
    // cart drawer and validation keep working
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        if (realBtn && !realBtn.disabled) {
          realBtn.click();
        } else if (form) {
          form.submit();
        }
      });
    }

    var show = function (on) {
      bar.classList.toggle('is-visible', on);
      // reserve space so the bar never sits on top of footer content
      document.body.classList.toggle('mgt-sticky-on', on);
      if (on) {
        document.documentElement.style.setProperty('--mgt-sticky-h', bar.offsetHeight + 'px');
      }
    };

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          // show the bar only once the real button has scrolled past
          show(!e.isIntersecting && e.boundingClientRect.top < 0);
        });
      }, { threshold: 0 }).observe(anchor);
    } else {
      window.addEventListener('scroll', function () {
        show(anchor.getBoundingClientRect().bottom < 0);
      }, { passive: true });
    }

    document.addEventListener('variant:change', function (evt) {
      var v = evt.detail && evt.detail.variant;
      if (!stickyBtn) return;
      if (!v || !v.available) {
        stickyBtn.disabled = true;
        stickyBtn.textContent = stickyBtn.getAttribute('data-sold-out') || 'Sold out';
        return;
      }
      stickyBtn.disabled = false;
      stickyBtn.textContent = stickyBtn.getAttribute('data-default') || 'Add to cart';
      if (priceNow) priceNow.textContent = money(v.price);
      if (priceWas) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          priceWas.textContent = money(v.compare_at_price);
          priceWas.hidden = false;
        } else {
          priceWas.hidden = true;
        }
      }
    });
  }

  function init() {
    initSticky();
    document.addEventListener('variant:change', function (evt) {
      updatePill(evt.detail && evt.detail.variant);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Motion re-renders product blocks on some navigations
  document.addEventListener('shopify:section:load', init);
})();
